/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */
import type {
  CreateFinaPremiseBody,
  Error,
  FinaBusinessPremise,
  FinaPremiseSuccessResponse,
  ValidationError
} from '../model';

import { customFetch } from '../../mutator/custom-fetch';

/**
 * List all business premises for the entity
 * @summary List business premises
 */
export type listFinaPremisesResponse200 = {
  data: FinaBusinessPremise[]
  status: 200
}

export type listFinaPremisesResponse400 = {
  data: Error
  status: 400
}

export type listFinaPremisesResponse401 = {
  data: Error
  status: 401
}

export type listFinaPremisesResponse403 = {
  data: Error
  status: 403
}

export type listFinaPremisesResponse404 = {
  data: Error
  status: 404
}

export type listFinaPremisesResponse500 = {
  data: Error
  status: 500
}

export type listFinaPremisesResponseSuccess = (listFinaPremisesResponse200) & {
  headers: Headers;
};
export type listFinaPremisesResponseError = (listFinaPremisesResponse400 | listFinaPremisesResponse401 | listFinaPremisesResponse403 | listFinaPremisesResponse404 | listFinaPremisesResponse500) & {
  headers: Headers;
};

export type listFinaPremisesResponse = (listFinaPremisesResponseSuccess | listFinaPremisesResponseError)

export const getListFinaPremisesUrl = () => {


  

  return `/fiscalization/fina/premises`
}

export const listFinaPremises = async ( options?: RequestInit): Promise<listFinaPremisesResponse> => {
  
  return customFetch<listFinaPremisesResponse>(getListFinaPremisesUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Add a business premise for FINA fiscalization. The premise must be registered on ePorezna first. Only the premise ID label is stored.
 * @summary Create business premise
 */
export type createFinaPremiseResponse201 = {
  data: FinaPremiseSuccessResponse
  status: 201
}

export type createFinaPremiseResponse400 = {
  data: Error
  status: 400
}

export type createFinaPremiseResponse401 = {
  data: Error
  status: 401
}

export type createFinaPremiseResponse403 = {
  data: Error
  status: 403
}

export type createFinaPremiseResponse404 = {
  data: Error
  status: 404
}

export type createFinaPremiseResponse422 = {
  data: ValidationError
  status: 422
}

export type createFinaPremiseResponse500 = {
  data: Error
  status: 500
}

export type createFinaPremiseResponseSuccess = (createFinaPremiseResponse201) & {
  headers: Headers;
};
export type createFinaPremiseResponseError = (createFinaPremiseResponse400 | createFinaPremiseResponse401 | createFinaPremiseResponse403 | createFinaPremiseResponse404 | createFinaPremiseResponse422 | createFinaPremiseResponse500) & {
  headers: Headers;
};

export type createFinaPremiseResponse = (createFinaPremiseResponseSuccess | createFinaPremiseResponseError)

export const getCreateFinaPremiseUrl = () => {


  

  return `/fiscalization/fina/premises`
}

export const createFinaPremise = async (createFinaPremiseBody: CreateFinaPremiseBody, options?: RequestInit): Promise<createFinaPremiseResponse> => {
  
  return customFetch<createFinaPremiseResponse>(getCreateFinaPremiseUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createFinaPremiseBody,)
  }
);}
  

/**
 * Get a single business premise by ID
 * @summary Get business premise
 */
export type getFinaPremiseResponse200 = {
  data: FinaBusinessPremise
  status: 200
}

export type getFinaPremiseResponse400 = {
  data: Error
  status: 400
}

export type getFinaPremiseResponse401 = {
  data: Error
  status: 401
}

export type getFinaPremiseResponse403 = {
  data: Error
  status: 403
}

export type getFinaPremiseResponse404 = {
  data: Error
  status: 404
}

export type getFinaPremiseResponse500 = {
  data: Error
  status: 500
}

export type getFinaPremiseResponseSuccess = (getFinaPremiseResponse200) & {
  headers: Headers;
};
export type getFinaPremiseResponseError = (getFinaPremiseResponse400 | getFinaPremiseResponse401 | getFinaPremiseResponse403 | getFinaPremiseResponse404 | getFinaPremiseResponse500) & {
  headers: Headers;
};

export type getFinaPremiseResponse = (getFinaPremiseResponseSuccess | getFinaPremiseResponseError)

export const getGetFinaPremiseUrl = (id: string,) => {


  

  return `/fiscalization/fina/premises/${id}`
}

export const getFinaPremise = async (id: string, options?: RequestInit): Promise<getFinaPremiseResponse> => {
  
  return customFetch<getFinaPremiseResponse>(getGetFinaPremiseUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Deactivate a business premise and all its devices.
 * @summary Delete business premise
 */
export type deleteFinaPremiseResponse200 = {
  data: FinaPremiseSuccessResponse
  status: 200
}

export type deleteFinaPremiseResponse400 = {
  data: Error
  status: 400
}

export type deleteFinaPremiseResponse401 = {
  data: Error
  status: 401
}

export type deleteFinaPremiseResponse403 = {
  data: Error
  status: 403
}

export type deleteFinaPremiseResponse404 = {
  data: Error
  status: 404
}

export type deleteFinaPremiseResponse422 = {
  data: ValidationError
  status: 422
}

export type deleteFinaPremiseResponse500 = {
  data: Error
  status: 500
}

export type deleteFinaPremiseResponseSuccess = (deleteFinaPremiseResponse200) & {
  headers: Headers;
};
export type deleteFinaPremiseResponseError = (deleteFinaPremiseResponse400 | deleteFinaPremiseResponse401 | deleteFinaPremiseResponse403 | deleteFinaPremiseResponse404 | deleteFinaPremiseResponse422 | deleteFinaPremiseResponse500) & {
  headers: Headers;
};

export type deleteFinaPremiseResponse = (deleteFinaPremiseResponseSuccess | deleteFinaPremiseResponseError)

export const getDeleteFinaPremiseUrl = (id: string,) => {


  

  return `/fiscalization/fina/premises/${id}`
}

export const deleteFinaPremise = async (id: string, options?: RequestInit): Promise<deleteFinaPremiseResponse> => {
  
  return customFetch<deleteFinaPremiseResponse>(getDeleteFinaPremiseUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}
  

